module.exports = __webpack_public_path__ + "static/media/p1.d1ee8558.svg";